export const StackDataReducer = (state = {}, action) => {
    switch (action.type) {
        case 'STACK_DATA':
            return action.stackData;
        default: return state;
    }
}